import { combineReducers, configureStore } from '@reduxjs/toolkit';
import {
  FLUSH,
  PAUSE,
  PERSIST,
  PURGE,
  REGISTER,
  REHYDRATE,
  persistStore,
} from 'redux-persist';
import { persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage';
import {
  createStateSyncMiddleware,
  initMessageListener,
} from 'redux-state-sync';
import { applicationSettingsSlice } from '@lon/shared/configs';
import { classDigitalNotebookReducer } from './class-digital-notebook';
import { classDigitalNotebookFeatureReducer } from './class-digital-notebook-feature';
import { classDigitalNotebookSelectedReducer } from './class-digital-notes-selected';
import { ClassDigitalNotebookStudentsStatus } from './class-digital-notes-student-status';
import { courseworkSearchFeatureFlagReducer } from './coursework-search-flag';
import { featureRudecer } from './feature';
import { authActions, authReducer } from './slices';
import { teacherResourcesFeatureFlagReducer } from './teacher-resources-feature';
import { assignementsReducer } from './assignments';
import { classDigitalNotebookSelectedComponentsReducer } from './class-digital-notebook-selected-components';
import { classDigitalNotebookSelectedStudentsReducer } from './class-digital-notes-selected-students';

const stateSyncMiddleware = createStateSyncMiddleware({
  whitelist: [authActions.setAuth.type],
});

const reducer = combineReducers({
  auth: authReducer,
  assignments: assignementsReducer,
  featureFlag: featureRudecer,
  applicationSettings: applicationSettingsSlice.default,
  teacherResourcesFeatureFlag: teacherResourcesFeatureFlagReducer,
  courseworkSearchFeatureFlag: courseworkSearchFeatureFlagReducer,
  classDigitalNotebookFeatureFlag: classDigitalNotebookFeatureReducer,
  classDigitalNotebook: classDigitalNotebookReducer,
  classDigitalNotebookSelected: classDigitalNotebookSelectedReducer,
  classDigitalNotebookSelectedStudents:
    classDigitalNotebookSelectedStudentsReducer,
  classDigitalNotebookSelectedComponents:
    classDigitalNotebookSelectedComponentsReducer,
  ClassDigitalNotebookStudentsStatus: ClassDigitalNotebookStudentsStatus,
});

export const store = configureStore({
  reducer: persistReducer(
    { key: 'mn', storage, whitelist: ['assignments'], blacklist: ['auth'] },
    reducer
  ),
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER],
      },
    }).concat(stateSyncMiddleware),
});

const persistor = persistStore(store);
initMessageListener(store);

export * from './types';
export * from './assignments';
export * from './feature';
export * from './teacher-resources-feature';
export * from './coursework-search-flag';
export { persistor, authActions };
